import { styled } from 'styled-components';
import type { OfViewMode } from '@fabric-app/types/resources';
import type { ZoomSliderProps } from '@fabric-app/ui/components/ZoomSlider/ZoomSlider';
import ZoomSlider from '@fabric-app/ui/components/ZoomSlider/ZoomSlider';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import { DropdownMenu } from '@fabric-app/ui/components/DropdownMenu/DropdownMenu';

export const ZoomSliderWithinDD = styled(ZoomSlider)`
  padding: 0.75rem;
  & > *:nth-child(1) {
    flex-grow: 1;
  }
`;

export const ZoomSliderWithinDropdownV2: React.FC<
  { viewMode: OfViewMode; steps?: number[] } & ZoomSliderProps
> = ({ viewMode, ...props }) => {
  const { isMobileView } = useResponsive();
  return !isMobileView && ['Grid', 'Masonry', 'Detailed'].includes(viewMode) ? (
    <>
      <DropdownMenu.Separator />
      <ZoomSliderWithinDD {...props} hideButtonControls showZoomLevel />
    </>
  ) : null;
};
